import { useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './features/auth/AuthContext';
import { TenantAccessProvider } from './features/platform/context';
import { AppRoutes } from './AppRoutes';
import { createQueryClient } from './app/queryClient';

export function App() {
  const [queryClient] = useState(createQueryClient);
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <TenantAccessProvider>
            <AppRoutes />
          </TenantAccessProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
